// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__10NIm","cell":"ColumnAccessor_cell__eYRT_","firstCellAccent":"ColumnAccessor_firstCellAccent__2iLoA"};